'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _cardConstants = require('./cardConstants');

var _elementRegistry = require('../elements/elementRegistry');

var _elementConstructor = require('../elements/elementConstructor');

var _elementConstructor2 = _interopRequireDefault(_elementConstructor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var objectConstructorFn = function objectConstructorFn(params) {
    var content = params.content;

    return _extends({}, (0, _elementConstructor2.default)(params), {
        elementType: _cardConstants.CARD_TYPE,
        content: _extends({
            textContent: null
        }, content)
    });
};

exports.default = function () {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return (0, _elementRegistry.registerElementType)(_extends({
        elementType: _cardConstants.CARD_TYPE,
        objectConstructorFn: objectConstructorFn,
        displayName: _cardConstants.CARD_DISPLAY_NAME
    }, params));
};


//////////////////
// WEBPACK FOOTER
// ./src/common/cards/index.js
// module id = 2254
// module chunks = 0